//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manba from 'manba'

export default {
  props: {
    history: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      }
    }
  },
  methods: {
    formatInitials: function (name) {
      if (!name) {
        return ''
      }
      const arrFullName = name.split(' ')
      return arrFullName[0] + ' ' +
             (arrFullName[1] ? (arrFullName[1].substring(0, 1) + '.') : '') + ' ' +
             (arrFullName[2] ? (arrFullName[2].substring(0, 1) + '.') : '')
    },
    formatDateTime: function (time) {
      return time ? manba(time).format('DD-MM-YYYY HH:mm') : ''
    },
    getClass: function (state) {
      let stateCls = ''
      switch (state) {
        case 'SK1':
          stateCls = ' bg-grey-4 '
          break
        case 'SK2':
          stateCls = ' bg-red-2 '
          break
        case 'SK3':
          stateCls = ' bg-yellow-3 '
          break
        case 'SK4':
          stateCls = ' bg-green-3 '
          break
        case 'SK5':
          stateCls = ' bg-light-blue-1 '
          break
        case 'SK6':
        case 'SK7':
        case 'SK8':
          stateCls = ' bg-red-7 text-white'
          break
        default:
          break
      }
      return stateCls
    }
  }
}
